import { loadStripe } from '@stripe/stripe-js';

/**
 * Safely loads Stripe with error handling
 * @param {string} publishableKey - Your Stripe publishable key
 * @returns {Promise<Stripe|null>} - Stripe instance or null if loading fails
 */
export const loadStripeSafely = async (publishableKey) => {
  if (!publishableKey) {
    console.error('Stripe publishable key is missing');
    return null;
  }

  try {
    const stripe = await loadStripe(publishableKey);
    return stripe;
  } catch (error) {
    console.error('Failed to load Stripe.js:', error);
    return null;
  }
};

/**
 * Creates a Stripe promise with error handling
 * @param {string} publishableKey - Your Stripe publishable key
 * @returns {Promise<Stripe|null>} - Promise that resolves to Stripe instance or null
 */
export const createStripePromise = (publishableKey) => {
  return new Promise((resolve) => {
    loadStripeSafely(publishableKey).then(resolve).catch(() => resolve(null));
  });
};